import { TabQueryState } from '@/components/layout/query-state';
import { TAB_BOTTOM_SPACING, TabScreenWrapper } from '@/components/layout/tab-screen-wrapper';
import { PageTitle } from '@/components/seo/page-title';
import { ProfileScreen } from '@/features/profile/profile-screen';
import { useProfileByIdentifier } from '@/features/profile/hooks/use-profile-by-identifier';
import { useAuth } from '@/hooks/use-auth';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { ScrollView } from 'react-native';

export default function ProfileRoute() {
  const { username } = useLocalSearchParams<{ username: string }>();
  const { user: currentUser } = useAuth();
  const { profileData, isLoading, error, refetch } = useProfileByIdentifier(username);

  const isCurrentUser = profileData?.user?.id === currentUser?.id;

  return (
    <TabQueryState
      isLoading={isLoading}
      error={error}
      onRetry={() => refetch()}
      loadingMessage="Loading profile..."
    >
      <PageTitle title={profileData?.user?.name || "Profile"} />
      {profileData?.user ? (
        <TabScreenWrapper>
          <ScrollView
            showsVerticalScrollIndicator={false}
            className="flex-1"
            contentContainerStyle={{ paddingBottom: TAB_BOTTOM_SPACING }}
          >
            <ProfileScreen
              user={profileData.user}
              isCurrentUser={isCurrentUser}
            />
          </ScrollView>
        </TabScreenWrapper>
      ) : null}
    </TabQueryState>
  );
}
